import { AllowedPermissions } from '@lucidlink/dto/validation';
import { UnauthorizedError } from '#common/types';
export const ADMIN_PRINCIPAL_ID = '00000000-0000-0000-0000-000000000001';
export const createIdService = (member, getFreshToken, getCurrentPrincipal, getPrincipalData, unlinkCb) => {
    return new IdServiceImpl(member, getFreshToken, getCurrentPrincipal, getPrincipalData, unlinkCb);
};
class IdServiceImpl {
    member;
    getFreshToken;
    getCurrentPrincipal;
    getPrincipalData;
    unlinkCb;
    constructor(member, getFreshToken, getCurrentPrincipal, getPrincipalData, unlinkCb) {
        this.member = member;
        this.getFreshToken = getFreshToken;
        this.getCurrentPrincipal = getCurrentPrincipal;
        this.getPrincipalData = getPrincipalData;
        this.unlinkCb = unlinkCb;
    }
    async getFilespaceAccessToken() {
        return await this.getFreshToken().catch(this.unlinkOnUnauthorized);
    }
    async getGroupsPrivateKeys() {
        let privateKeys = {};
        const principalInfo = await this.getCurrentPrincipalInfo().catch(this.unlinkOnUnauthorized);
        if (principalInfo.isAdmin) {
            privateKeys[ADMIN_PRINCIPAL_ID] = (await this.member.getAdminCryptoKeys()).privateKey;
        }
        else {
            privateKeys = principalInfo.groupPrivateKeys;
        }
        return Promise.resolve({ principalId: this.member.getId(), privateKeys });
    }
    getCurrentPrincipalInfo() {
        return this.getCurrentPrincipal();
    }
    async getPrincipalAllowedPermissions(principalId) {
        const data = await this.getPrincipalData(principalId);
        if (!data || !data.allowedPermissions) {
            return AllowedPermissions.NONE;
        }
        return data.allowedPermissions;
    }
    getAdminGroupId() {
        return ADMIN_PRINCIPAL_ID;
    }
    async getPrincipalsCrypto(principalIds) {
        const res = {};
        await Promise.all(principalIds.map(async (principalId) => {
            const keys = principalId === ADMIN_PRINCIPAL_ID
                ? await this.member.getAdminCryptoKeys().catch(() => undefined)
                : (await this.getPrincipalData(principalId))?.keys;
            if (keys) {
                res[principalId] = keys;
            }
        }));
        return res;
    }
    unlinkOnUnauthorized = (error) => {
        if (error instanceof UnauthorizedError) {
            void this.unlinkCb();
        }
        throw error;
    };
}
